import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import { ResponseBusinessTravelContact } from "./postBusinessContactApiInterface";

class BusinessTravelServiceApi {
  private baseUrl: string;

  private basePathV2: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePathV2 = "v2/";
  }

  // ******************************************************
  // ****************** Method: GET ***********************
  // ******************************************************

  // ******************************************************
  // ****************** Method: POST **********************
  // ******************************************************
  async postBusinessContact(body: any): Promise<ResponseBusinessTravelContact> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}BusinessTravel`,
      "POST",
      body,
    )) as any;

    return new ResponseBusinessTravelContact(response);
  }
}

export default BusinessTravelServiceApi;
